/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import RoundedButton from '../buttons/Rounded';
import CardLayout from '../partials/CardLayout';
import Date from '../partials/Date';
import Link from '../partials/Link';

import styles from '../../../styles/cards/article.module.scss';

const propTypes = {
    item: AppPropTypes.article,
    isStacked: PropTypes.bool,
    isDark: PropTypes.bool,
    withDescription: PropTypes.bool,
    withButton: PropTypes.bool,
    placeholderIndex: PropTypes.number,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    isStacked: false,
    isDark: false,
    withDescription: true,
    withButton: true,
    placeholderIndex: null,
    className: null,
};

const ArticleCard = ({
    item,
    isStacked,
    isDark,
    withDescription,
    withButton,
    placeholderIndex,
    className,
}) => {
    const {
        title = null,
        url = null,
        image = null,
        description = null,
        author = null,
        publishedAt = null,
        document = null,
        blocks = [],
    } = item;

    const { url: documentUrl = null } = document || {};
    const { name: authorName } = author || {};
    const isDownload = (blocks || []).length === 0 && documentUrl !== null;
    const finalUrl = (blocks || []).length === 0 && documentUrl !== null ? documentUrl : url;

    const button = isDownload ? (
        <RoundedButton className={styles.button} href={documentUrl} external isDark={isDark}>
            <FormattedMessage defaultMessage="Download the pdf" description="Button label" />
        </RoundedButton>
    ) : (
        <RoundedButton className={styles.button} href={url} isDark={isDark}>
            <FormattedMessage defaultMessage="Read the article" description="button label" />
        </RoundedButton>
    );

    return (
        <CardLayout
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            type="article"
            isStacked={isStacked}
            url={finalUrl}
            external={isDownload}
            image={image}
            placeholderIndex={placeholderIndex}
        >
            <div className={styles.content}>
                {publishedAt !== null ? (
                    <Date
                        className={classNames(styles.topDate)}
                        date={publishedAt}
                        withoutWeekday
                        withoutTime
                    />
                ) : null}
                <Link href={finalUrl} external={isDownload} className={styles.link}>
                    {title !== null ? <h3 className={styles.title}>{title}</h3> : null}
                </Link>
                {author !== null ? (
                    <h4 className={classNames(styles.info, styles.author)}>{authorName}</h4>
                ) : null}
                {withDescription && description !== null ? (
                    <h4 className={classNames(styles.info, styles.description)}>{description}</h4>
                ) : null}
            </div>
            {withButton ? button : null}
        </CardLayout>
    );
};

ArticleCard.propTypes = propTypes;
ArticleCard.defaultProps = defaultProps;

export default ArticleCard;
